import React from "react";
import { PropTypes } from "prop-types";

const ItunesIcon = ({ size, color, children, ...props }) => (
  <svg {...props} viewBox="0 0 24 24" width={size} height={size} fill={color}>
    {children}
    <g
      id="Logos/Social/Fill/Itunes-24"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon id="Fill-1" points="0 0 24 0 24 24 0 24" />
      <g
        id="itunes"
        transform="translate(1.000000, 1.000000)"
        fill={color}
        fillRule="nonzero"
      >
        <path
          d="M10.9762924,0.122100606 C5.10470391,0.122100606 0.345079004,4.88172551 0.345079004,10.753314 C0.345079004,16.6249438 5.10470391,21.3845687 10.9762924,21.3845687 C16.8479222,21.3845687 21.6075471,16.624985 21.6075471,10.753314 C21.6075471,4.88172551 16.8479222,0.122100606 10.9762924,0.122100606 Z M10.9762924,1.29547792 C16.1991392,1.29547792 20.434211,5.53054967 20.434211,10.7533553 C20.434211,15.9762021 16.1991392,20.2112738 10.9762924,20.2112738 C5.75348682,20.2112738 1.52728274,15.9762021 1.52728274,10.7533553 C1.52728274,5.53054967 5.75348682,1.29547792 10.9762924,1.29547792 L10.9762924,1.29547792 Z"
          id="Shape"
        />
        <path
          d="M15.4064527,3.66190639 L8.03408457,5.65543935 L8.02554687,5.65543935 L8.02554687,8.654194 L8.03408457,8.654194 L8.03408457,14.0160363 C7.71154913,13.8219376 7.31613389,13.7066992 6.891311,13.7066992 C5.79695899,13.7066992 4.91514216,14.4667197 4.91514216,15.3993916 C4.91514216,16.3323521 5.79720646,17.0835875 6.891311,17.0835875 C7.98541554,17.0835875 8.91532397,16.3315685 8.87630626,15.3994328 L8.85621997,14.9209915 L8.80755094,8.43918413 L14.6332751,6.86663828 L14.6332751,12.7869371 C14.293128,12.5524183 13.8589426,12.4088859 13.3873891,12.4088859 C12.2930371,12.4088859 11.4109316,13.1689064 11.4109316,14.1015783 C11.4109316,15.0345388 12.2930371,15.785733 13.3873891,15.785733 C14.4817412,15.785733 15.4015033,15.0345388 15.4015033,14.1015783 C15.4015033,14.0927931 15.401792,14.0845441 15.4015033,14.0757177 L15.4067414,6.6601661 L15.4067414,3.66190639 L15.4064527,3.66190639 L15.4064527,3.66190639 Z"
          id="Path"
        />
      </g>
    </g>
  </svg>
);

ItunesIcon.displayName = "ItunesIcon";

ItunesIcon.defaultProps = {
  color: "currentColor",
  children: null
};

ItunesIcon.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  children: PropTypes.node
};

export default ItunesIcon;
